import { apiClient } from '@/shared/api/client.js';

export interface AdminUserView {
  id: string;
  email: string;
  displayName: string;
  role: 'user' | 'superadmin';
}

export interface ListUsersResponse {
  items: AdminUserView[];
}

export interface CreateUserInput {
  email: string;
  password: string;
  displayName: string;
  role?: 'user' | 'superadmin';
}

export interface CreateUserResponse {
  user: AdminUserView;
}

export const adminApi = {
  async listUsers(): Promise<ListUsersResponse> {
    const { data } = await apiClient.get<ListUsersResponse>('/admin/users');
    return data;
  },

  async createUser(input: CreateUserInput): Promise<CreateUserResponse> {
    const { data } = await apiClient.post<CreateUserResponse>(
      '/admin/users',
      input,
    );
    return data;
  },
};
